import { styled } from '@material-ui/core/styles';

// ----------- Breackpoints -----------
// xs, extra-small: 0px
// sm, small: 600px
// md, medium: 900px
// lg, large: 1200px
// xl, extra-large: 1536px

const Homeviewbodyfield = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('xs')]: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 2%)',
        height: 'auto',
        gap: '0.2vh',
        marginLeft: '1%',
        marginRight: '1%',
        marginBottom: '0',
        boxSizing: 'border-box',
        flexShrink: '0',
    },
    [theme.breakpoints.up('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 2%)',
        height: 'auto',
        gap: '0.2vh',
        marginLeft: '1%',
        marginRight: '1%',
        marginBottom: '0',
        boxSizing: 'border-box',
        flexShrink: '0',
    },
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row',
        width: 'calc(100% - 2%)',
        height: 'auto',
        minHeight: '35vh',
        maxHeight: 'none',
        gap: '1%',
        marginLeft: '1%',
        marginRight: '1%',
        marginBottom: '0',
        marginTop: '0.7%',
        boxSizing: 'border-box',
        flexShrink: '0',
    },
    [theme.breakpoints.up('lg')]: {
        display: 'flex',
        flexDirection: 'row',
        width: 'calc(100% - 2%)',
        height: '39%',
        minHeight: '38vh',
        maxHeight: 'none',
        gap: '1%',
        marginLeft: '1%',
        marginRight: '1%',
        marginBottom: '0',
        boxSizing: 'border-box',
        flexShrink: '0',
    }
}));

const EstatusLineaComp = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('xs')]: {
        background: '#ffffff 0% 0% no-repeat padding-box',
        boxShadow: '1px 2px 4px #00000014',
        borderRadius: '3px',
        opacity: '1',
        width: '96%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: '0',
        overflowY: 'auto',
        overflowX: 'hidden',
        alignSelf: 'flex-end',
        marginRight: '0',
    },
    [theme.breakpoints.up('sm')]: {
        background: '#ffffff 0% 0% no-repeat padding-box',
        boxShadow: '1px 2px 4px #00000014',
        borderRadius: '3px',
        opacity: '1',
        width: '96%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: '0',
        overflowY: 'auto',
        overflowX: 'hidden',
        alignSelf: 'flex-end',
        marginRight: '0',
    },
    [theme.breakpoints.up('md')]: {
        background: '#ffffff 0% 0% no-repeat padding-box',
        boxShadow: '1px 2px 4px #00000014',
        borderRadius: '3px',
        opacity: '1',
        flex: '1',
        minWidth: '0',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        alignSelf: 'stretch',
    },
    [theme.breakpoints.up('lg')]: {
        background: '#ffffff 0% 0% no-repeat padding-box',
        boxShadow: '1px 2px 4px #00000014',
        borderRadius: '3px',
        opacity: '1',
        flex: '1',
        minWidth: '0',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        alignSelf: 'stretch',
    }
}));

const EstatusDeLineField = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('xs')]: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: '0',
        marginRight: '0',
        marginTop: '0',
        marginBottom: '0',
        flexShrink: '0',
    },
    [theme.breakpoints.up('sm')]: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: '0',
        marginRight: '0',
        marginTop: '0',
        marginBottom: '0',
        flexShrink: '0',
    },
    [theme.breakpoints.up('md')]: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: '0',
        marginRight: '0',
        marginTop: '0',
        marginBottom: '0',
        flexShrink: '0',
    },
    [theme.breakpoints.up('lg')]: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: '0',
        marginRight: '0',
        marginTop: '0',
        marginBottom: '0',
        flexShrink: '0',
    }
}));

const EstatusDeLineaButton = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('xs')]: {
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginRight: '0',
        marginLeft: 'auto',
        flexShrink: '0',
    },
    [theme.breakpoints.up('sm')]: {
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginRight: '0',
        marginLeft: 'auto',
        flexShrink: '0',
    },
    [theme.breakpoints.up('md')]: {
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginRight: '0',
        marginLeft: 'auto',
        flexShrink: '0',
    },
    [theme.breakpoints.up('lg')]: {
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginRight: '0',
        marginLeft: 'auto',
        flexShrink: '0',
    },
}));

const GraficasConteosLinea = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('xs')]: {
        marginTop: '2%',
        marginLeft: '5%',
        marginRight: '5%',
        display: 'flex',
        flexDirection: 'column',
        width: '90%',
    },
    [theme.breakpoints.up('sm')]: {
        marginTop: '2%',
        marginLeft: '5%',
        marginRight: '5%',
        display: 'flex',
        flexDirection: 'column',
        width: '90%',
    },
    [theme.breakpoints.up('md')]: {
        marginTop: '2%',
        marginLeft: '5%',
        marginRight: '5%',
        display: 'flex',
        flexDirection: 'column',
        width: '90%',
    },
    [theme.breakpoints.up('lg')]: {
        width: '100%', /* Ocupa todo el ancho del contenedor padre */
        height: '300px', /* Define una altura fija o ajustable */
        maxheight: '400px', /* Puedes limitar la altura máxima */
        overflow: 'hidden', /* Evita que los elementos desborden */
    },
}));

const ANDONcallscomp = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('xs')]: {
        marginTop: '0',
        marginBottom: '0',
        marginLeft: '1%',
        marginRight: '1%',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 2%)',
        height: 'auto',
        minHeight: '20vh',
        flexShrink: '0',
    },
    [theme.breakpoints.up('sm')]: {
        marginTop: '0',
        marginBottom: '0',
        marginLeft: '1%',
        marginRight: '1%',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 2%)',
        height: 'auto',
        minHeight: '18vh',
        flexShrink: '0',
    },
    [theme.breakpoints.up('md')]: {
        marginTop: '0',
        marginBottom: '0',
        marginLeft: '1%',
        marginRight: '1%',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 2%)',
        height: 'auto',
        minHeight: '16vh',
        flexShrink: '0',
    },
    [theme.breakpoints.up('lg')]: {
        marginTop: '0',
        marginBottom: '0',
        marginLeft: '1%',
        marginRight: '1%',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 2%)',
        height: '28vh',
        maxHeight: '28vh',
        minHeight: '28vh',
        flexShrink: '0',
    },
    [theme.breakpoints.up('xl')]: {
        marginTop: '0',
        marginBottom: '0',
        marginLeft: '1%',
        marginRight: '1%',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 2%)',
        height: '30vh',
        maxHeight: '30vh',
        minHeight: '30vh',
        flexShrink: '0',
    },
}));



export { EstatusDeLineField, EstatusDeLineaButton, GraficasConteosLinea, EstatusLineaComp, Homeviewbodyfield, ANDONcallscomp}